import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShareV3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.00009 20L1.53809 2.25C14.6038 6.05 26.9248 12.0529 37.9701 20C26.9255 27.9469 14.6051 33.9498 1.54009 37.75L7.00009 20ZM7.00009 20H22.0001",
		stroke: "url(#paint0_linear_share_v3)",
		strokeWidth: 3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_share_v3",
		x1: -11.5,
		y1: 38,
		x2: 48.1565,
		y2: 5.45384,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "rgb(var(--repeatmd-brand-color))"
		})]
	}) })]
});
export default SvgShareV3;
